module.exports = __webpack_public_path__ + "img/ebook-hero-thumb3.41366280.png";